/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const escoSkillCatalogDataSchema = z.object({
	id: z.string(),
	conceptUri: z.string(),
	preferredLabel: z.string(),
})

export type EscoSkillCatalogDataSchema = z.infer<typeof escoSkillCatalogDataSchema>
